import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Hub from 'base/hub'
import Event from 'base/event'

import NewUserModal from 'desktop/components/modals/new_user_modal'

class LoginModal extends Component {
  static propTypes = {
    onRequestClose: PropTypes.func,
    onExplicitClose: PropTypes.func,
    onSignInSuccess: PropTypes.func,
    onSignUpSuccess: PropTypes.func,
    showGuestCheckoutMessaging: PropTypes.bool,
    siteLocation: PropTypes.string,
    skipEmailEntry: PropTypes.bool,
    isNewUser: PropTypes.bool,
    email: PropTypes.string,
    isSigningIn: PropTypes.bool,
    allowLocalhostDevLogin: PropTypes.bool,
  }

  static defaultProps = {
    skipEmailEntry: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      isNewUser: this.checkNewUser(props),
    }
  }

  componentDidMount() {
    return Hub.pub(Event.Login.MODAL_VIEW, {
      site_location: this.props.siteLocation,
    })
  }

  checkNewUser(props) {
    if (props.isNewUser) {
      return props.isNewUser
    }
    if (props.skipEmailEntry) {
      return false
    }
    return undefined
  }

  handleSignInSuccess = () => {
    this.props.onSignInSuccess && this.props.onSignInSuccess()
    this.props.onRequestClose && this.props.onRequestClose()
  }

  handleSignUpSuccess = () => {
    this.props.onSignUpSuccess && this.props.onSignUpSuccess()
    this.props.onRequestClose && this.props.onRequestClose()
  }

  handleExplicitRequestClose = () => {
    const onClose = this.props.onExplicitClose || this.props.onRequestClose

    if (!onClose) {
      return
    }

    Hub.pub(Event.Login.MODAL_CLOSED, {
      site_location: this.props.siteLocation,
    })

    onClose()
  }

  render() {
    return (
      <NewUserModal
        siteLocation={this.props.siteLocation}
        onSignInSuccess={this.handleSignInSuccess}
        onRequestClose={this.handleExplicitRequestClose}
        skipEmailEntry={this.props.skipEmailEntry}
        isSigningIn={this.props.isSigningIn}
        allowLocalhostDevLogin={this.props.allowLocalhostDevLogin}
      />
    )
  }
}

export default LoginModal
